const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const integrityManage = () => import(/* webpackChunkName: "integrity" */ './integrityManage');

export default {
    routes: [
        {
            path: '/integrity/index',
            name: 'integrity_index',
            component: Index
        },
        {
            path: 'integrity/integrityManage/:dbid',
            name: 'integrity_integrityManage',
            component: integrityManage
        },
    ]
}
